import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        customerName: {
            label: "姓名",
            visible: true,
            width: "100",
            align: "left",
        },
        mobile: {
            label: "联系方式",
            visible: true,
            width: "120",
            align: "left",
        },
        gender: {
            label: "性别",
            visible: true,
            width: "100",
            align: "left",
        },
        docNo: {
            label: "卡号",
            visible: true,
            width: '180',
            align: "left",
        },
        symptom: {
            label: "档案部位",
            visible: true,
            width: 'auto',
            minWidth: "auto",
            align: "left",
        },
        nextRepairTime: {
            label: "下次登记时间",
            visible: true,
            width: "120",
            formatDay: true,
            align: "left",
        },
        recordTime: {
            label: "开卡日期",
            visible: true,
            width: "120",
            formatDay: true,
            align: "left",
        },
        staffIdCn: {
            label: "登记技师",
            visible: true,
            width: "100",
            align: "left",
        }  
    },
};